import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTiposActividadState,
  entityTiposActividadAdapter
} from './entity-tipos-actividad.state';
import {
  entityTiposActividadLoadFailure,
  entityTiposActividadLoadRequest,
  entityTiposActividadLoadSuccess
} from './entity-tipos-actividad.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTiposActividadLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTiposActividadLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTiposActividadLoadSuccess, (state, { items }) =>
    entityTiposActividadAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function tiposActividadReducer(
  state: EntityTiposActividadState | undefined,
  action: Action
) {
  return reducer(state, action);
}
